import './global.scss';
import { mapGetters, mapActions } from 'vuex';
import Utils from '../../lib/utils';
import PageTitle from '../../lib/pageTitle';
import ApiConfig from '../../config/api';

export default {
  name: 'Global',

  created() {
    window.addEventListener('popstate', this.onPopState);
    window.addEventListener('load', this.onLoad);
  },
  computed: {
    ...mapGetters('results/', ['textResults', 'videoResults']),
    ...mapGetters([
      'urlParams',
      'product',
      'defaultPageTitle',
    ]),
  },
  methods: {
    ...mapActions([
      'updatePrevItemLink',
      'getElementFromFaqList',
      'updateFirstFaqBackLink',
    ]),
    onPopState(e) {
      if (typeof e !== 'undefined' && e.state && e.state != null) {
        this.updatePrevItemLink(e.state);
        this.$store.dispatch('updateUrlParams', { params: e.state, pushHistoryEntryFlag: true });

        if (
          !this.$store.getters.canUserSearch(e.state)
          && !this.$store.getters.canUserIdentifyProduct(e.state)
          && !this.$store.getters.urlParams.faq
        ) {
          this.$store.commit('noProductFlowFlagUpdate', false);
        }

        if (e.state.textPage || e.state.videoPage) {
          const { textPage } = e.state;
          const { videoPage } = e.state;

          const textResults = Utils.getObjectCopy(this.textResults);
          const videoResults = Utils.getObjectCopy(this.videoResults);

          if (e.state.textPage >= 1
            && textResults
            && textResults.contentDetails.length > 0) {
            let numToShow = ApiConfig.textResultsPerPage;
            numToShow += ApiConfig.textResultsPerPage * textPage;
            if (numToShow < textResults.contentDetails.length) {
              textResults.contentDetails = textResults.contentDetails.slice(0, numToShow);
              this.$store.commit('results/textResultsUpdate', textResults);
            }
          }

          if (e.state.videoPage >= 1
            && videoResults
            && videoResults.contentDetails.length > 0) {
            let numToShow = ApiConfig.videoResultsPerPage;
            numToShow += ApiConfig.videoResultsPerPage * videoPage;
            if (numToShow < videoResults.contentDetails.length) {
              videoResults.contentDetails = videoResults.contentDetails.slice(0, numToShow);
              this.$store.commit('results/videoResultsUpdate', videoResults);
            }
          }
        }

        if (!e.state.faq && !e.state.productID) {
          PageTitle.constructTitle([this.defaultPageTitle]);
        } else if (
          !e.state.faq && e.state.productID
          && typeof this.product.displayName !== 'undefined'
        ) {
          PageTitle.constructTitle([this.product.displayName, this.defaultPageTitle]);
        }

        this.handleProductSelectorPage(e.state);
      } else {
        this.$store.commit('noProductFlowFlagUpdate', false);
      }

      this.handleBackToHome();
    },

    handleBackToHome() {
      const hasAnyParams = window.location.href.split('?').length > 1;
      if (!this.$store.getters.noProductFlowFlag && !hasAnyParams) {
        this.$store.dispatch('resetState');
      }
    },

    async onLoad() {
      await this.$store.dispatch('setParamsViaURL');
      Utils.setProductRegistrationTimestamp();

      const prevFaq = await this.getElementFromFaqList();
      if (prevFaq) {
        this.$store.commit('prevFaqUpdate', prevFaq);
      }

      if (this.urlParams.tab === 'welcome') {
        this.updateFirstFaqBackLink();
      }

      if (this.urlParams.topicTag || this.urlParams.searchQuery) {
        this.updatePrevItemLink();
        this.updateFirstFaqBackLink();
      } else if (this.urlParams.faq) {
        this.updateFirstFaqBackLink();
      }

      if (this.urlParams.topicTag) {
        this.$store.commit('isTopicSelectedFlagUpdate', true);
      }
      if (this.urlParams.searchQuery) {
        this.$store.commit('isSearchQuerySubmittedFlagUpdate', true);
      }

      if (
        this.$store.getters.isSearchTypeNoProduct
        && !this.$store.getters.canUserIdentifyProduct(this.urlParams)
        && !this.$store.getters.canUserSearch(this.urlParams)
        && !this.$store.getters.urlParams.faq
      ) {
        this.$store.dispatch('noProductFlowEnable');
      }

      this.handleProductSelectorPage(this.urlParams);

      this.$emit('globalInitializationComplete', true);
    },

    handleProductSelectorPage(params) {
      if (params.productSearch) {
        const searchTerm = decodeURIComponent(params.productSearch);
        const fuzzyMatchedProducts = this.$store.getters.productListByTerm(searchTerm);

        if (fuzzyMatchedProducts.length >= 2 && fuzzyMatchedProducts.length <= 20) {
          this.$store.commit('productFilteredListUpdate', fuzzyMatchedProducts);
          this.$store.commit('isQuickLinkClickedFlagUpdate', false);
        }
      }
    },
  },
};
